import BaseService from "@services/BaseService";

export default class CompanyService extends BaseService {
  entity = "companies";
}
